import { render, staticRenderFns } from "./QuestionCheckboxes.vue?vue&type=template&id=928affd6"
import script from "./QuestionCheckboxes.vue?vue&type=script&lang=js"
export * from "./QuestionCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports